// extracted by mini-css-extract-plugin
export default {"mapContainer":"Map_mapContainer__eA2+f","body":"Map_body__b5lHD","iframe":"Map_iframe__uIPo+"};